namespace SSi.Blazor.Common.Shared.Services.Confirm {

    export function showConfirm(message) {
        return confirm(message);
    };

    export function setOnBeforeUnload() {
        window.onbeforeunload = () => "Are you sure you want to leave this page?";
    }

    export function clearOnBeforeUnload() {
        window.onbeforeunload = null;
    }
}